import { Field } from "formik";
import {
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";

const CustomInputComponent = props => (
  <input className="form-control" type="text" {...props} />
);

export const FieldCustom = props => {
  const {
    id,
    type,
    value,
    onChange,
    onBlur,
    validate,
    className,
    icon,
    // alt,
    placeHolder,
    ...otherProps
  } = props;
  return (
    <FormGroup>
      <InputGroup className={className}>
        <Field
          as={CustomInputComponent}
          {...otherProps}
          id={id}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeHolder}
          validate={validate}
        />
        <InputGroupAddon addonType="append">
          <InputGroupText>{icon}</InputGroupText>
        </InputGroupAddon>
      </InputGroup>
    </FormGroup>
  );
};
